var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "analytics 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2124",
    d: "M21.9535 19.3713L24.3607 21.7787L31.9998 29.4177L29.4126 32.0049L21.7736 24.3659L19.3662 21.9585",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2128",
    d: "M9.34799 14.8402C9.34799 13.8298 8.52909 13.0109 7.51872 13.0109C6.50836 13.0109 5.68945 13.8298 5.68945 14.8402C5.68945 15.8505 6.50836 16.6694 7.51872 16.6694C8.52909 16.6694 9.34799 15.8505 9.34799 14.8402Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2132",
    d: "M14.8353 9.35237C14.8353 8.342 14.0164 7.5231 13.006 7.5231C11.9957 7.5231 11.1768 8.342 11.1768 9.35237C11.1768 10.3627 11.9957 11.1816 13.006 11.1816C14.0164 11.1816 14.8353 10.3627 14.8353 9.35237Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2136",
    d: "M20.3236 14.8402C20.3236 13.8298 19.5047 13.0109 18.4943 13.0109C17.9894 13.0109 17.5321 13.2158 17.201 13.5469C16.8699 13.878 16.665 14.3353 16.665 14.8402C16.665 15.8505 17.4839 16.6694 18.4943 16.6694C19.5047 16.6694 20.3236 15.8505 20.3236 14.8402Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2140",
    d: "M8.8125 13.5469L11.7131 10.6463",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2144",
    d: "M14.2998 10.6463L17.2004 13.5469",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2148",
    d: "M19.7881 13.5469L23.5125 9.82248L26.3472 6.98772",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2152",
    d: "M29.4691 5.69417C29.4691 6.70453 28.6502 7.52344 27.6398 7.52344C26.6295 7.52344 25.8105 6.70453 25.8105 5.69417C25.8105 4.6838 26.6295 3.8649 27.6398 3.8649C28.6502 3.8649 29.4691 4.6838 29.4691 5.69417Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2156",
    d: "M21.7734 24.3657L24.3606 21.7785",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2164",
    d: "M10.2538 2.35454C17.4591 0.936222 22.403 6.15448 23.5122 9.82278C23.8177 10.8325 23.9817 11.9033 23.9817 13.0112C23.9817 15.3813 23.2299 17.5764 21.9525 19.371C21.2403 20.3703 20.3653 21.2454 19.3659 21.9575C17.5714 23.235 15.3762 23.9868 13.0061 23.9868C6.94452 23.9868 2 19.0728 2 13.0112C2 7.89936 5.51647 3.58198 10.2538 2.35454Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.f1d8f2fe1a1ac5bb284578965f5135d2.svg";
export { ForwardRef as ReactComponent };